module.exports = __webpack_public_path__ + "media/user_registration/images/check_mail_graphic-e44c1dd71c8e15a6a00cfdad91660b1e.png";